import { useDispatch, useSelector } from "react-redux";
import { useGetTechniciansForJobMutation } from "../../../Store/Builder/schedule.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import {
  setTechnician,
  setTechnicianLocations,
  setTechniciansForJob,
} from "../../../Store/Slice/scheduleSlice";

/** Map / technicians/for-job payload → marker fields used by `Map` (lat, lon, tag, name). */
function technicianJobResponseToLocations(res) {
  if (res?.technicianLocations != null) return res.technicianLocations;
  if (!Array.isArray(res)) return [];
  return res
    .filter((t) => {
      const lat = parseFloat(t?.lat);
      const lon = parseFloat(t?.lon);
      return !Number.isNaN(lat) && !Number.isNaN(lon);
    })
    .map((t) => ({
      lat: t.lat,
      lon: t.lon,
      tag: t.tag,
      name:
        [t.firstname, t.lastname].filter(Boolean).join(" ").trim() ||
        String(t.id ?? ""),
    }));
}

const useGetTechniciansForJob = () => {
  const dispatch = useDispatch();
  const [techniciansApi] = useGetTechniciansForJobMutation();
  const {lat, lon, job_datetime: date} = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const duration = useSelector((state) => state.rootReducer.scheduleSlice.total_time);
  const radius = useSelector((state) => state.rootReducer.scheduleSlice.radius);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const lineItems = useSelector((state) => state.rootReducer.scheduleSlice.line_items);

  const get = (queryParams) => {
    dispatch(setLoader(true))
    const params = {
      lat: queryParams?.lat || lat,
      lon: queryParams?.lon || lon,
      date: queryParams?.date || date,
      duration: queryParams?.duration || duration,
      radius: queryParams?.radius || radius,
      job_except: +activeJob?.id,
      product_ids: queryParams?.product_ids || lineItems?.map(item => item?.product?.value),
    };

    techniciansApi(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setTechniciansForJob(res));
        dispatch(setTechnicianLocations(technicianJobResponseToLocations(res)));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        dispatch(setTechnician({ date: null, time: null }));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
  };
};

export default useGetTechniciansForJob;
